module.exports = __webpack_public_path__ + "img/7.3d2eff2c.png";